import React, { useState, useEffect } from 'react';
import './Banner.css';
import MovingComponent from 'react-moving-text';
import { useNavigate } from 'react-router-dom';
import Black from './assets/black.jpg';
import Count from './Countdown/Count';

const videoURLs = [
  require('./assets/KIP1.mp4'),
  require('./assets/KIP2.mp4'),
 require('./assets/KIP3.mp4'),
 require('./assets/KIP4.mp4'),
  // Add more video URLs here
];

function Banner() {
  const navigate = useNavigate();
  const targetDate = '2023-06-21T00:00:00';

  const [randomVideoIndex, setRandomVideoIndex] = useState(0);

  useEffect(() => {
    // Generate a random index to select a video
    const newIndex = Math.floor(Math.random() * videoURLs.length);
    setRandomVideoIndex(newIndex);
  }, []);

  return (
    <div className="main">
      <div className="backcover" style={{ backgroundImage: `url(${Black})` }} />
      <video className="video" src={videoURLs[randomVideoIndex]} autoPlay loop muted preload="auto" />
      <div className='overlay' />
      <div className='content'>
        <MovingComponent
          type="slideInFromLeft"
          duration="1000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          <h1 className='header'>KIPPRA Annual Regional Conference</h1>
          <p className='topic'>Accelerating Economic Growth and Development for ASALs in Kenya</p>
        </MovingComponent>
        <MovingComponent
          type="slideInFromLeft"
          duration="1000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          <div className='countmob'>
            <Count targetDate={targetDate} />
          </div>
        </MovingComponent>
        <div className='count'>
          <Count targetDate={targetDate} />
        </div>
      </div>
    </div>
  )
}

export default Banner;
